export default {
    url: 'https://novamark-uat-api.hubblehox.ai'
}